"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _Button = _interopRequireDefault(require("../Button"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SearchInput = function SearchInput(props) {
  var useHotkey = props.useHotkey,
      className = props.className,
      classes = props.classes,
      style = props.style,
      onSearch = props.onSearch,
      initialWidth = props.initialWidth,
      maxWidth = props.maxWidth,
      onChange = props.onChange,
      suggestions = props.suggestions,
      maxSuggestions = props.maxSuggestions,
      renderSuggestion = props.renderSuggestion,
      mustSelectSuggestion = props.mustSelectSuggestion,
      onClear = props.onClear,
      searchOnChange = props.searchOnChange,
      placeholder = props.placeholder,
      others = (0, _objectWithoutProperties2.default)(props, ["useHotkey", "className", "classes", "style", "onSearch", "initialWidth", "maxWidth", "onChange", "suggestions", "maxSuggestions", "renderSuggestion", "mustSelectSuggestion", "onClear", "searchOnChange", "placeholder"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      inputRef = _useState4[0],
      setInputRef = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      renderedSuggestions = _useState6[0],
      setRenderedSuggestions = _useState6[1];

  var _useState7 = (0, _react.useState)(others.value || ""),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      value = _useState8[0],
      setValue = _useState8[1];

  var sortSuggestions = function sortSuggestions(a, b) {
    return a.index < b.index ? -1 : a.index > b.index ? 1 : a.value.text < b.value.text ? -1 : a.value.text > b.value.text ? 1 : 0;
  };

  var getSuggestions = (0, _react.useCallback)(function (value) {
    var testValue = value.trim().toLowerCase();

    if (testValue.length > 0) {
      var weightedSuggestions = [];
      suggestions.forEach(function (suggestion) {
        var index = suggestion.text.toLowerCase().indexOf(testValue);
        if (index !== -1) weightedSuggestions.push({
          value: suggestion,
          index: index
        });
      });
      weightedSuggestions.sort(sortSuggestions);
      setRenderedSuggestions(weightedSuggestions.slice(0, maxSuggestions).map(function (weightedSuggestion) {
        return weightedSuggestion.value;
      }));
    } else {
      setRenderedSuggestions([]);
    }
  }, [maxSuggestions, suggestions]);

  var handleFocus = function handleFocus() {
    return setFocused(true);
  };

  var handleBlur = function handleBlur() {
    return setFocused(false);
  };

  var handleClear = function handleClear() {
    if (typeof onChange === "function") onChange({
      target: {
        value: ""
      }
    });
    if (typeof onClear === "function") onClear();
    setValue("");
  };

  var handleSearch = function handleSearch() {
    if (typeof onSearch === "function") {
      inputRef && inputRef.blur();
      setTimeout(function () {
        return handleBlur();
      }, 100); // Small delay added to ensure animation fired

      onSearch(value);
    }
  };

  (0, _react.useEffect)(function () {
    var listener;

    if (inputRef && useHotkey) {
      listener = function listener(event) {
        if ((event.ctrlKey || event.metaKey) && event.key === "k") {
          event.preventDefault();
          inputRef.focus();
          inputRef.select();
        }
      };

      document.addEventListener("keydown", listener);
    }

    return function () {
      if (inputRef && useHotkey) {
        document.removeEventListener("keydown", listener);
      }
    };
  }, [inputRef, useHotkey]);
  (0, _react.useEffect)(function () {
    if (others.value && value !== others.value) {
      setValue(others.value);
      if (suggestions) getSuggestions(others.value);
    }
  }, [value, others.value, suggestions, getSuggestions]);

  var handleKeyDown = function handleKeyDown(event) {
    // Handle enter press on input
    if (event.keyCode === 13) {
      handleSearch(value);
    } else if (event.key === "Escape") {
      inputRef && inputRef.blur();
      handleBlur();
    }
  };

  var handleChange = function handleChange(e, suggestStuff) {
    if (suggestions) {
      var newValue = suggestStuff.newValue,
          method = suggestStuff.method;
      setValue(newValue);

      if (method === "type") {
        getSuggestions(newValue);
        if (typeof onChange === "function") onChange({
          target: {
            value: newValue
          }
        });
      } else if (method === "click") {
        onSearch(newValue);
      } else if (method === "enter") {
        onSearch(newValue);
      }
    } else {
      if (typeof onChange === "function") onChange(e);
      setValue(e.target.value);
    }
  };

  var getInputRef = function getInputRef(ref) {
    if (ref) setInputRef(ref.input);
  };

  var renderInputComponent = function renderInputComponent(props) {
    var ref = props.ref,
        others = (0, _objectWithoutProperties2.default)(props, ["ref"]);
    if (typeof ref === "function") ref(inputRef);
    return /*#__PURE__*/_react.default.createElement(_TextInput.default, others);
  };

  var inputProps = _objectSpread(_objectSpread({
    className: (0, _classnames.default)(className, classes.root),
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    style: {
      width: focused ? "100%" : "".concat(initialWidth, "%")
    },
    onFocus: handleFocus,
    onBlur: handleBlur,
    placeholder: placeholder,
    inputProps: "label" in others ? undefined : {
      "aria-label": placeholder
    }
  }, others), {}, {
    endAdornment: (onChange || mustSelectSuggestion) && searchOnChange ? value === "" ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      "aria-label": "Search",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    }))) : /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      title: "Clear search",
      onClick: handleClear
    }, /*#__PURE__*/_react.default.createElement(_Clear.default, {
      fontSize: "small"
    }))) : value === "" ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      "aria-label": "Search",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    }))) : /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      title: "Search",
      onClick: handleSearch
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    }))),
    innerRef: getInputRef
  });

  var renderSuggestionsContainer = function renderSuggestionsContainer(_ref) {
    var containerProps = _ref.containerProps,
        children = _ref.children;
    return /*#__PURE__*/_react.default.createElement(_Fade.default, {
      in: true
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, containerProps, children));
  };

  renderSuggestionsContainer.propTypes = {
    containerProps: _propTypes.default.object,
    children: _propTypes.default.node
  };

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    setRenderedSuggestions([]);
  };

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested() {// do nothing
  };

  var localRenderSuggestion = function localRenderSuggestion(suggestion, otherProps) {
    if (typeof renderSuggestion === "function") {
      return renderSuggestion(suggestion, otherProps);
    } else {
      var query = otherProps.query;
      var queryIndexStart = suggestion.text.toLowerCase().indexOf(query.toLowerCase());
      var queryIndexEnd = queryIndexStart + query.length;
      var before = suggestion.text.slice(0, queryIndexStart);
      var highlighted = suggestion.text.slice(queryIndexStart, queryIndexEnd);
      var after = suggestion.text.slice(queryIndexEnd, suggestion.text.length);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, before, /*#__PURE__*/_react.default.createElement("strong", null, highlighted), after);
    }
  };

  var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.text;
  };

  var theme = {
    container: classes.container,
    suggestionsContainer: classes.suggestionsContainer,
    suggestionsList: classes.suggestionsList,
    suggestion: classes.suggestion,
    suggestionHighlighted: classes.suggestionHighlighted
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.outerWrapper,
    style: _objectSpread({
      maxWidth: maxWidth
    }, style)
  }, suggestions ? /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, {
    suggestions: renderedSuggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: localRenderSuggestion,
    inputProps: inputProps,
    renderInputComponent: renderInputComponent,
    theme: theme,
    renderSuggestionsContainer: renderSuggestionsContainer,
    focusInputOnSuggestionClick: false,
    highlightFirstSuggestion: mustSelectSuggestion,
    "aria-label": placeholder
  }) : /*#__PURE__*/_react.default.createElement(_TextInput.default, inputProps));
};

SearchInput.propTypes = {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * Whether to bind to CTRL+K or not
   */
  useHotkey: _propTypes.default.bool,

  /**
   * The current value (only if controlled; if provided you must use onChange)
   */
  value: _propTypes.default.string,

  /**
   * The short hint displayed in the input before the user enters a value
   */
  placeholder: _propTypes.default.string,

  /**
   * Callback when value is changed. (value) => {}. If provided, a clear button will take the place of the search button when text is typed.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback when search is performed. (value) => {}
   */
  onSearch: _propTypes.default.func,

  /**
   * The width when the element is not focused, as a percentage of the maxWidth (0-100)
   */
  initialWidth: _propTypes.default.number,

  /**
   * The width when the element is focused, (css value; include unit)
   */
  maxWidth: _propTypes.default.string,

  /**
   * All possible suggestions for the search autocomplete
   */
  suggestions: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired
  })),

  /**
   * The maximum number of suggestions to show
   */
  maxSuggestions: _propTypes.default.number,

  /**
   * If true, when a search is performed the first suggestion will be used as the query. The clear button will replace the search button as well.
   */
  mustSelectSuggestion: _propTypes.default.bool,

  /**
   * A callback that is fired when the clear button is clicked. Note: an onChange event with an empty string will also be fired.
   */
  onClear: _propTypes.default.func,

  /**
   * Allows custom rendering of the search suggestions
   */
  renderSuggestion: _propTypes.default.func,

  /**
   * If set to true, the clear button will always show. This should be used when onChange performs the search.
   */
  searchOnChange: _propTypes.default.bool,

  /**
   * If set to false, margin will be removed.
   */
  margin: _propTypes.default.bool,

  /** @ignore */
  className: _propTypes.default.string,

  /** @ignore */
  classes: _propTypes.default.object.isRequired,

  /**
   * Additional styles to render
   */
  style: _propTypes.default.object,

  /**
   * A callback function that gets a ref to the SearchInput
   */
  ref: _propTypes.default.func
};
SearchInput.defaultProps = {
  placeholder: "Search...",
  initialWidth: 100,
  maxWidth: "100%",
  maxSuggestions: 6
};

var _default = (0, _styles2.withStyles)(_styles.styles)(SearchInput);

exports.default = _default;